/**
 * Post-action event-listen — after ANY Intrlock-initiated write action succeeds,
 * poll the target device state 3× at 1.5s intervals to catch the resulting
 * state transition. Compensates for PDK subscriptions being deleted (§28.518.64)
 * and CBW/other-vendor push events being one-way ingestion (not real-time to SPA).
 *
 * Called from every action button's onClick after connector-api returns 200.
 *
 * P-OPT-2 per-property scoping contract (§28.518.67):
 * - refreshFn MUST poll only the single device's property, never the full fleet.
 * - Fire-and-forget (no await at call site) so button UI doesn't block on 4.5s window.
 * - Individual poll failures are swallowed — they don't cascade to the calling handler.
 * - If document is hidden when a poll fires, the poll is skipped to avoid waking
 *   the tab unnecessarily (visibility guard mirrors §28.518.xx idle-poll pattern).
 */
export async function pollAfterAction(
  refreshFn: () => Promise<void>,
  deviceId: string,
  action: string,
  attempts: number = 3,
  intervalMs: number = 1500,
): Promise<void> {
  console.info('[EVENT_LISTEN]', { device_id: deviceId, action, at: new Date().toISOString() });
  for (let i = 0; i < attempts; i++) {
    await new Promise((r) => setTimeout(r, intervalMs));
    // Skip poll if tab is hidden — mirrors existing idle-poll visibility guard.
    if (document.hidden) continue;
    try {
      await refreshFn();
    } catch {
      /* swallow; individual poll failures don't cascade */
    }
  }
}
